import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_EA_CASE = "GET_EA_CASE";

export const service = async (eaCaseId) => {
  const options: object = {
    url: '/api/EaCaseApiController/GetExternalAuditCase/' + eaCaseId,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_EA_CASE, service, mock);
